import SongStore from '../stores/SongStore';

export default function SongSaveAction(actionContext, payload, callback) {
	var songData = actionContext.getStore(SongStore).dehydrate();

	if(!songData.name) {
        songData.name = "song-" + Date.now();
    }

    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(songData));

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = dataStr;
    // the filename you want
    a.download = songData.name + ".json";
    a.click();

    callback(null, songData);

}
